/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Markdown table generator. Fill a grid, set column alignment, and get a clean, aligned GitHub-flavored Markdown table. Runs in your browser.`)
};

const es_mt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador gratuito de tablas Markdown. Rellena una cuadrícula, configura la alineación de columnas y obtén una tabla Markdown limpia y alineada compatible con GitHub. Se ejecuta en tu navegador.`)
};

const de_mt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Markdown-Tabellengenerator. Füllen Sie ein Raster aus, legen Sie die Spaltenausrichtung fest und erhalten Sie eine saubere, ausgerichtete GitHub Flavored Markdown-Tabelle. Läuft direkt in Ihrem Browser.`)
};

const nl_mt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Markdown-tabelgenerator. Vul een raster in, stel kolomuitlijning in en krijg een schone, uitgelijnde GitHub Flavored Markdown-tabel. Werkt in uw browser.`)
};

const fr_mt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de tableau Markdown gratuit. Remplissez une grille, définissez l'alignement des colonnes et obtenez un tableau Markdown GitHub Flavored propre et aligné. S'exécute dans votre navigateur.`)
};

const it_mt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore gratuito di tabelle Markdown. Riempire una griglia, impostare l'allineamento delle colonne e ottenere una tabella Markdown con flavour GitHub pulita e allineata. Funziona nel vostro browser.`)
};

const pt_br2_mt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de tabelas Markdown gratuito. Preencha uma grade, defina o alinhamento das colunas e obtenha uma tabela Markdown limpa e alinhada compatível com GitHub. Funciona no seu navegador.`)
};

const pt_mt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de tabelas Markdown gratuito. Preencha uma grelha, defina o alinhamento das colunas e obtenha uma tabela Markdown compatível com GitHub, limpa e alinhada. Funciona no seu navegador.`)
};

const ja_mt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の Markdown テーブルジェネレーター。グリッドに入力し、列の配置を設定して、きれいで配置された GitHub 風 Markdown テーブルを生成します。ブラウザで動作します。`)
};

const zh_mt_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的 Markdown 表格生成器。填写网格、设置列对齐方式，即可获得整洁对齐的 GitHub Flavored Markdown 表格。全部在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_tool_description", locale)
	if (locale === "en") return en_mt_tool_description(inputs)
	if (locale === "es") return es_mt_tool_description(inputs)
	if (locale === "de") return de_mt_tool_description(inputs)
	if (locale === "nl") return nl_mt_tool_description(inputs)
	if (locale === "fr") return fr_mt_tool_description(inputs)
	if (locale === "it") return it_mt_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_mt_tool_description(inputs)
	if (locale === "pt") return pt_mt_tool_description(inputs)
	if (locale === "ja") return ja_mt_tool_description(inputs)
	return zh_mt_tool_description(inputs)
};